
import React, { useState, useEffect, createContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateSupplier from "./create/createSupplier";
import UpdateSupplier from "./update/updateSupplier";

const SupplierContext = createContext();

function Supplier() {

  const [dataList, setDataList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const openUpdate = (SupplierID, SupplierName, Tell, Address) => {
    var list = [];
    list.push({
      SupplierID: SupplierID,
      SupplierName: SupplierName,
      Tell: Tell,
      Address: Address
    });
    setData(list);
    setShowUpdate(true);
  };

  const Search = event => {

    const { value } = event.target;
    if(value){
      var results = [];
      results = dataList.filter((data) => {
          return data.SupplierName.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
        setShowData(results);
      else 
        setShowData(dataList);
    } else 
    setShowData(dataList);
  }
  
  useEffect(() => {
    let objData = localStorage.getItem("supplierData");
    if (objData) {
      let data = JSON.parse(objData);
      setDataList(data);
      setShowData(data);
    } 
  }, []);

  return (
    <SupplierContext.Provider value={{dataList, setDataList, setShowData, data}}>
    <div className="formContent">
        <CreateSupplier show={show} onClick={handleClose}/>
        <UpdateSupplier show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
            <div className="title">
                <span>ຂໍ້ມູນ ຜູ້ສະໜອງ</span>
            </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow}>ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ID</th>
                <th>ຊື່ຜູ້ສະໜອງ</th>
                <th>ເບີໂທ</th>
                <th>ທີ່ຢູ່</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.SupplierName}</td>
                        <td >{x.Tell}</td>
                        <td >{x.Address}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.SupplierID} type="button" onClick={() => openUpdate(x.SupplierID, x.SupplierName, x.Tell, x.Address)}>Edit</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
    </div>
     </SupplierContext.Provider>
  );
};
export {SupplierContext};
export default Supplier;
